import type { FlowScreenConfig } from "@/shared/constants/flowTypes";
import { LtcInsuranceReview } from "../components/LtcInsuranceReview";
import { AddLtcInsurance } from "../components/AddLtcInsurance";

export function createLtcInsuranceScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "ltc_insurance_review",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: LtcInsuranceReview,
      shouldDisplay: ({ answers }) =>
        !answers["has_ltc_insurance"] && answers["ltc_insurance_review"] !== "none",
    },
    {
      id: "has_ltc_insurance",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} have long-term care insurance?`,
      subtitle:
        "LTC policies may provide benefits for care costs or have a cash value or death benefit.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had LTC insurance" },
          { value: "no", label: "No LTC insurance" },
          { value: "not_sure", label: "I'm not sure" },
        ],
      },
      shouldDisplay: ({ answers }) => answers["ltc_insurance_review"] === "none",
    },
    {
      id: "add_ltc_insurance",
      layout: "full",
      maxWidth: "4xl",
      hideButton: true,
      customComponent: AddLtcInsurance,
      shouldDisplay: ({ answers }) =>
        answers["has_ltc_insurance"] === "yes" &&
        (answers["add_ltc_insurance"] === "yes" || answers["ltc_insurance_review"] === "none"),
    },
    {
      id: "ltc_insurance_manage",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: LtcInsuranceReview,
      shouldDisplay: ({ answers }) =>
        answers["ltc_insurance_review"] === "found" && answers["ltc_insurance_manage"] === "yes",
    },
  ];
}
